import api from 'services/api';
import { FrontendError } from 'types';

export const logFrontendError = async (frontendError: FrontendError) => {
  await api('/frontend-errors', {
    method: 'POST',
    data: frontendError,
  });
};
